import SummaryAllergies from './Allergies'

export default SummaryAllergies
